// extracted by mini-css-extract-plugin
export var button = "_9q-4";
export var hasDarkBackground = "_9q-7";
export var hasLightBackground = "_9q-6";
export var iconWrapper = "_9q-0";
export var large = "_9q-2";
export var medium = "_9q-1";
export var small = "_9q-5";
export var xsmall = "_9q-3";